import { render, staticRenderFns } from "./TransactionsContent.vue?vue&type=template&id=3ff4d31c"
import script from "./TransactionsContent.vue?vue&type=script&lang=js"
export * from "./TransactionsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports